import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext'
import { RouterProvider } from 'react-router-dom';
import { Provider } from "react-redux";
import store from "./redux/store";
import reportWebVitals from './reportWebVitals';
import { router } from './router.jsx'
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.min.css';
import SessionExpiredModal from './Components/SessionExpiredModal.jsx';

let isSessionExpired = false;

const originalFetch = window.fetch;

window.fetch = async (...args) => {
    try {
        const response = await originalFetch(...args);

        if (response.status === 401 && !isSessionExpired) {
            isSessionExpired = true;
            window.dispatchEvent(new Event('session-expired'));
        }

        return response;
    } catch (error) {
        throw error;
    }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SessionExpiredModal/>
      <AuthProvider>
        <ToastContainer />
        <RouterProvider router={router} />
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
